import { App, defineAsyncComponent } from "vue";

const icons = {
  // Outline
  ArrowDownTrayIcon: () =>
    import("@heroicons/vue/24/outline/ArrowDownTrayIcon.js"),
  StarIcon: () => import("@heroicons/vue/24/outline/StarIcon.js"),
  TrashIcon: () => import("@heroicons/vue/24/outline/TrashIcon.js"),
  CogIcon: () => import("@heroicons/vue/24/outline/CogIcon.js"),
  XCircleIcon: () => import("@heroicons/vue/24/outline/XCircleIcon.js"),
  CheckCircleIcon: () => import("@heroicons/vue/24/outline/CheckCircleIcon.js"),
  ArrowUpIcon: () => import("@heroicons/vue/24/outline/ArrowUpIcon.js"),
  ExclamationCircleIcon: () =>
    import("@heroicons/vue/24/outline/ExclamationCircleIcon.js"),
  UserGroupIcon: () => import("@heroicons/vue/24/outline/UserGroupIcon.js"),
  UsersIcon: () => import("@heroicons/vue/24/outline/UsersIcon.js"),
  InformationCircleIcon: () =>
    import("@heroicons/vue/24/outline/InformationCircleIcon.js"),
  HomeIcon: () => import("@heroicons/vue/24/outline/HomeIcon.js"),
  ChevronRightIcon: () =>
    import("@heroicons/vue/24/outline/ChevronRightIcon.js"),
  ChevronLeftIcon: () => import("@heroicons/vue/24/outline/ChevronLeftIcon.js"),
  CheckIcon: () => import("@heroicons/vue/24/outline/CheckIcon.js"),
  ChevronUpIcon: () => import("@heroicons/vue/24/outline/ChevronUpIcon.js"),
  ChevronDownIcon: () => import("@heroicons/vue/24/outline/ChevronDownIcon.js"),
  UserIcon: () => import("@heroicons/vue/24/outline/UserIcon.js"),
  CalendarIcon: () => import("@heroicons/vue/24/outline/CalendarIcon.js"),
  PencilIcon: () => import("@heroicons/vue/24/outline/PencilIcon.js"),
  PlusIcon: () => import("@heroicons/vue/24/outline/PlusIcon.js"),
  PlusCircleIcon: () => import("@heroicons/vue/24/outline/PlusCircleIcon.js"),
  TagIcon: () => import("@heroicons/vue/24/outline/TagIcon.js"),
  ArrowRightIcon: () => import("@heroicons/vue/24/outline/ArrowRightIcon.js"),
  ClockIcon: () => import("@heroicons/vue/24/outline/ClockIcon.js"),
  CubeIcon: () => import("@heroicons/vue/24/outline/CubeIcon.js"),
  MicrophoneIcon: () => import("@heroicons/vue/24/outline/MicrophoneIcon.js"),
  PaperClipIcon: () => import("@heroicons/vue/24/outline/PaperClipIcon.js"),
  BellIcon: () => import("@heroicons/vue/24/outline/BellIcon.js"),
  PlayIcon: () => import("@heroicons/vue/24/outline/PlayIcon.js"),
  PauseIcon: () => import("@heroicons/vue/24/outline/PauseIcon.js"),
  EyeIcon: () => import("@heroicons/vue/24/outline/EyeIcon.js"),
  ShieldCheckIcon: () => import("@heroicons/vue/24/outline/ShieldCheckIcon.js"),
  AtSymbolIcon: () => import("@heroicons/vue/24/outline/AtSymbolIcon.js"),
  DocumentTextIcon: () =>
    import("@heroicons/vue/24/outline/DocumentTextIcon.js"),
  Bars3BottomLeftIcon: () =>
    import("@heroicons/vue/24/outline/Bars3BottomLeftIcon.js"),
  XMarkIcon: () => import("@heroicons/vue/24/outline/XMarkIcon.js"),
  EllipsisVerticalIcon: () =>
    import("@heroicons/vue/24/outline/EllipsisVerticalIcon.js"),
  DocumentPlusIcon: () =>
    import("@heroicons/vue/24/outline/DocumentPlusIcon.js"),
  ArrowRightEndOnRectangleIcon: () =>
    import("@heroicons/vue/24/outline/ArrowRightEndOnRectangleIcon.js"),
  BarsArrowUpIcon: () => import("@heroicons/vue/24/outline/BarsArrowUpIcon.js"),
  ArrowDownIcon: () => import("@heroicons/vue/24/outline/ArrowDownIcon.js"),
  DevicePhoneMobileIcon: () =>
    import("@heroicons/vue/24/outline/DevicePhoneMobileIcon.js"),
  EnvelopeIcon: () => import("@heroicons/vue/24/outline/EnvelopeIcon.js"),
  ChatBubbleLeftEllipsisIcon: () =>
    import("@heroicons/vue/24/outline/ChatBubbleLeftEllipsisIcon.js"),
  ExclamationTriangleIcon: () =>
    import("@heroicons/vue/24/outline/ExclamationTriangleIcon.js"),
  ViewColumnsIcon: () => import("@heroicons/vue/24/outline/ViewColumnsIcon.js"),
  AdjustmentsVerticalIcon: () =>
    import("@heroicons/vue/24/outline/AdjustmentsVerticalIcon.js"),
  ChevronUpDownIcon: () =>
    import("@heroicons/vue/24/outline/ChevronUpDownIcon.js"),
  FolderPlusIcon: () => import("@heroicons/vue/24/outline/FolderPlusIcon.js"),
  ArrowUpTrayIcon: () => import("@heroicons/vue/24/outline/ArrowUpTrayIcon.js"),
  MagnifyingGlassIcon: () =>
    import("@heroicons/vue/24/outline/MagnifyingGlassIcon.js"),
  ArrowTrendingUpIcon: () =>
    import("@heroicons/vue/24/outline/ArrowTrendingUpIcon.js"),
  MapPinIcon: () => import("@heroicons/vue/24/outline/MapPinIcon.js"),
  TableCellsIcon: () => import("@heroicons/vue/24/outline/TableCellsIcon.js"),
  RectangleGroupIcon: () =>
    import("@heroicons/vue/24/outline/RectangleGroupIcon.js"),
  ComputerDesktopIcon: () =>
    import("@heroicons/vue/24/outline/ComputerDesktopIcon.js"),
  NoSymbolIcon: () => import("@heroicons/vue/24/outline/NoSymbolIcon.js"),
  PencilSquareIcon: () =>
    import("@heroicons/vue/24/outline/PencilSquareIcon.js"),
  ArrowsPointingOutIcon: () =>
    import("@heroicons/vue/24/outline/ArrowsPointingOutIcon.js"),
  BuildingOfficeIcon: () =>
    import("@heroicons/vue/24/outline/BuildingOfficeIcon.js"),
  ArrowPathIcon: () => import("@heroicons/vue/24/outline/ArrowPathIcon.js"),
  FaceSmileIcon: () => import("@heroicons/vue/24/outline/FaceSmileIcon.js"),
  FunnelIcon: () => import("@heroicons/vue/24/outline/FunnelIcon.js"),
  ArrowUturnLeftIcon: () =>
    import("@heroicons/vue/24/outline/ArrowUturnLeftIcon.js"),
  ChartBarSquareIcon: () =>
    import("@heroicons/vue/24/outline/ChartBarSquareIcon.js"),
  BarsArrowDownIcon: () =>
    import("@heroicons/vue/24/outline/BarsArrowDownIcon.js"),
  EllipsisHorizontalCircleIcon: () =>
    import("@heroicons/vue/24/outline/EllipsisHorizontalCircleIcon.js"),
  GlobeAltIcon: () => import("@heroicons/vue/24/outline/GlobeAltIcon.js"),
  FlagIcon: () => import("@heroicons/vue/24/outline/FlagIcon.js"),
  ChatBubbleOvalLeftEllipsisIcon: () =>
    import("@heroicons/vue/24/outline/ChatBubbleOvalLeftEllipsisIcon.js"),
  ChatBubbleLeftRightIcon: () =>
    import("@heroicons/vue/24/outline/ChatBubbleLeftRightIcon.js"),
  ArrowUturnRightIcon: () =>
    import("@heroicons/vue/24/outline/ArrowUturnRightIcon.js"),
  QueueListIcon: () => import("@heroicons/vue/24/outline/QueueListIcon.js"),
  QuestionMarkCircleIcon: () =>
    import("@heroicons/vue/24/outline/QuestionMarkCircleIcon.js"),
  Squares2X2Icon: () => import("@heroicons/vue/24/outline/Squares2X2Icon.js"),
  ArrowsRightLeftIcon: () =>
    import("@heroicons/vue/24/outline/ArrowsRightLeftIcon.js"),
  MegaphoneIcon: () => import("@heroicons/vue/24/outline/MegaphoneIcon.js"),
  Square2StackIcon: () =>
    import("@heroicons/vue/24/outline/Square2StackIcon.js"),
  SpeakerWaveIcon: () => import("@heroicons/vue/24/outline/SpeakerWaveIcon.js"),
  ChartBarIcon: () => import("@heroicons/vue/24/outline/ChartBarIcon.js"),
  Battery50Icon: () => import("@heroicons/vue/24/outline/Battery50Icon.js"),
  Battery100Icon: () => import("@heroicons/vue/24/outline/Battery100Icon.js"),
  Battery0Icon: () => import("@heroicons/vue/24/outline/Battery0Icon.js"),
  KeyIcon: () => import("@heroicons/vue/24/outline/KeyIcon.js"),
  MinusCircleIcon: () => import("@heroicons/vue/24/outline/MinusCircleIcon.js"),
  BoltIcon: () => import("@heroicons/vue/24/outline/BoltIcon.js"),
  PaperAirplaneIcon: () =>
    import("@heroicons/vue/24/outline/PaperAirplaneIcon.js"),
  ArrowLeftIcon: () => import("@heroicons/vue/24/outline/ArrowLeftIcon.js"),
  ArrowTopRightOnSquareIcon: () =>
    import("@heroicons/vue/24/outline/ArrowTopRightOnSquareIcon.js"),
  ScaleIcon: () => import("@heroicons/vue/24/outline/ScaleIcon.js"),
  DocumentMagnifyingGlassIcon: () =>
    import("@heroicons/vue/24/outline/DocumentMagnifyingGlassIcon.js"),

  // Solid
  StarIconSolid: () => import("@heroicons/vue/24/solid/StarIcon.js"),
  ChevronRightIconSolid: () =>
    import("@heroicons/vue/24/solid/ChevronRightIcon.js"),
  XCircleIconSolid: () => import("@heroicons/vue/24/solid/XCircleIcon.js"),
  ChevronDownIconSolid: () =>
    import("@heroicons/vue/24/solid/ChevronDownIcon.js"),
  CheckIconSolid: () => import("@heroicons/vue/24/solid/CheckIcon.js"),
  TrashIconSolid: () => import("@heroicons/vue/24/solid/TrashIcon.js"),
  ChevronUpIconSolid: () => import("@heroicons/vue/24/solid/ChevronUpIcon.js"),
  PaperAirplaneIconSolid: () =>
    import("@heroicons/vue/24/solid/PaperAirplaneIcon.js"),
  InboxIconSolid: () => import("@heroicons/vue/24/solid/InboxIcon.js"),
  PhoneIconSolid: () => import("@heroicons/vue/24/solid/PhoneIcon.js"),
  UserIconSolid: () => import("@heroicons/vue/24/solid/UserIcon.js"),
  ClockIconSolid: () => import("@heroicons/vue/24/solid/ClockIcon.js"),
  ChevronLeftIconSolid: () =>
    import("@heroicons/vue/24/solid/ChevronLeftIcon.js"),
  PencilIconSolid: () => import("@heroicons/vue/24/solid/PencilIcon.js"),
  FireIconSolid: () => import("@heroicons/vue/24/solid/FireIcon.js"),
  HeartIconSolid: () => import("@heroicons/vue/24/solid/HeartIcon.js"),
  PaperClipIconSolid: () => import("@heroicons/vue/24/solid/PaperClipIcon.js"),
  LightBulbIconSolid: () => import("@heroicons/vue/24/solid/LightBulbIcon.js"),
  XMarkIconSolid: () => import("@heroicons/vue/24/solid/XMarkIcon.js"),
  ExclamationTriangleIconSolid: () =>
    import("@heroicons/vue/24/solid/ExclamationTriangleIcon.js"),
  FaceSmileIconSolid: () => import("@heroicons/vue/24/solid/FaceSmileIcon.js"),
  FaceFrownIconSolid: () => import("@heroicons/vue/24/solid/FaceFrownIcon.js"),
  HandThumbUpIconSolid: () =>
    import("@heroicons/vue/24/solid/HandThumbUpIcon.js"),
  EllipsisVerticalIconSolid: () =>
    import("@heroicons/vue/24/solid/EllipsisVerticalIcon.js"),
  ArrowDownTrayIconSolid: () =>
    import("@heroicons/vue/24/solid/ArrowDownTrayIcon.js"),
  MagnifyingGlassIconSolid: () =>
    import("@heroicons/vue/24/solid/MagnifyingGlassIcon.js"),
  PencilSquareIconSolid: () =>
    import("@heroicons/vue/24/solid/PencilSquareIcon.js"),
  ArchiveBoxIconSolid: () =>
    import("@heroicons/vue/24/solid/ArchiveBoxIcon.js"),
  ChevronUpDownIconSolid: () =>
    import("@heroicons/vue/24/solid/ChevronUpDownIcon.js"),
  AdjustmentsVerticalIconSolid: () =>
    import("@heroicons/vue/24/solid/AdjustmentsVerticalIcon.js"),
  AdjustmentsHorizontalIconSolid: () =>
    import("@heroicons/vue/24/solid/AdjustmentsHorizontalIcon.js"),
  ArrowUpTrayIconSolid: () =>
    import("@heroicons/vue/24/solid/ArrowUpTrayIcon.js"),
  MapPinIconSolid: () => import("@heroicons/vue/24/solid/MapPinIcon.js"),
};

export const registerIcons = (app: App): void => {
  for (const [name, loader] of Object.entries(icons)) {
    app.component(name, defineAsyncComponent(loader));
  }
};
